import React from 'react';
import packageJson from '../../../package.json';
import AwsChatbot from '../AwsChatbot';

// Mock data for PCD showcase
const mockPcdData = [
  { id: 'pcd-001', type: 'Blood Pressure Monitor', status: 'Connected', lastSync: '2023-10-27T10:00:00Z', reading: '120/80 mmHg' },
  { id: 'pcd-002', type: 'Glucose Meter', status: 'Connected', lastSync: '2023-10-27T10:05:00Z', reading: '95 mg/dL' },
  { id: 'pcd-003', type: 'Smart Scale', status: 'Disconnected', lastSync: '2023-10-26T08:30:00Z', reading: '155 lbs' },
  { id: 'pcd-004', type: 'Fitness Tracker', status: 'Connected', lastSync: '2023-10-27T10:10:00Z', reading: '8,500 steps' },
];

const styles = {
  container: { padding: '2rem', fontFamily: 'sans-serif' },
  header: { borderBottom: '2px solid #eee', paddingBottom: '1rem', marginBottom: '2rem' },
  card: { border: '1px solid #ddd', borderRadius: '8px', padding: '1rem', marginBottom: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  cardHeader: { fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.5rem' },
  statusConnected: { color: 'green', fontWeight: 'bold' },
  statusDisconnected: { color: 'red', fontWeight: 'bold' },
};

const PCDPage = () => {
  return (
    <div style={styles.container} className="ecosystem-page">
      <header style={styles.header}>
        <h1>Personal Cloud Dashboard (PCD) Showcase</h1>
        <div className="badge-alpha">Alpha Stage</div>
        <p>This is a demonstration of how integrated device data could be displayed in the dashboard.</p>
        <p>Version: {packageJson.version}</p>
        <p>PCD extensions enable the dedicated resources via migration of local Android health data to private Kubernetes-orchestrated clusters.</p>
      </header>

      <div>
        {mockPcdData.map(device => (
          <div key={device.id} style={styles.card}>
            <h3 style={styles.cardHeader}>{device.type}</h3>
            <p>Status:
              <span style={device.status === 'Connected' ? styles.statusConnected : styles.statusDisconnected}>
                {' '}{device.status}
              </span>
            </p>
            <p>Last Reading: {device.reading}</p>
            <p><small>Last Synced: {new Date(device.lastSync).toLocaleString()}</small></p>
          </div>
        ))}
      </div>
      <AwsChatbot />
    </div>
  );
};

export default PCDPage;